<template>
  <b-modal
    id="modal-send-broadcast"
    hide-header
    centered
    size="lg"
    @hidden="handleModalHidden"
  >
    <div
      style="max-height: 80vh; overflow-y: auto; overflow-x: hidden;"
      class="p-1"
    >
      <div class="grid mt-1 mb-3 gap-4">
        <div class="text-2xl text-black text-center">
          {{ broadcast.type === 'new' ? 'Pilih Penerima Broadcast Kamu!' : 'Broadcast Ulang ke Kontak yang Gagal Terkirim' }}
        </div>
        <div class="text-center">
          {{ broadcast.type === 'new' ? 'Silahkan pilih Target Broadcast dari Grup Kontak' : 'Periksa nomor kontak yang gagal menerima broadcast sebelumnya.' }}
        </div>
      </div>
      <div class="border border-2 rounded-lg md:p-2 p-1 mt-2 border-[#E2E2E2]">
        <b-form-group
          id="broadcast-title-group"
          label="Judul Broadcast"
          label-for="broadcast-title"
        >
          <b-form-input
            id="broadcast-title"
            v-model="broadcast.title"
            placeholder="judul broadcast"
            disabled
          />
        </b-form-group>
        <b-form-group
          id="broadcast-content-group"
          label="Pesan"
          label-for="broadcast-content"
        >
          <template #label>
            <div class="flex justify-between">
              <span class="text-base">Pesan</span>
              <div>
                <div
                  v-if="spintaxContent.length"
                  class="flex bg-[#F4F4F4] rounded h-fit w-fit items-center p-[4px] gap-1"
                >
                  <button
                    :disabled="indexVariant === 0"
                    class="px-[4px] py-[2px] rounded "
                    :class="indexVariant === 0 ? 'bg-[#F4F4F4]': 'bg-white' "
                    @click="handleMoveVariant('min')"
                  >
                    <b-icon
                      icon="chevron-left"
                    />
                  </button>
                  <span class="mx-1 text-sm">{{ variantNames }}</span>
                  <button
                    :disabled="indexVariant === spintaxContent.length -1"
                    :class="indexVariant === spintaxContent.length - 1 ? 'bg-[#F4F4F4]': 'bg-white' "
                    class="px-[4px] rounded py-[2px] "
                    @click="handleMoveVariant('plus')"
                  >
                    <b-icon
                      icon="chevron-right"
                    />
                  </button>
                </div>
              </div>
            </div>
          </template>
          <b-form-textarea
            v-show="content"
            id="broadcast-content"
            v-model="content"
            disabled
            :rows="6"
            maxlength="1000"
          />
          <div class="text-right">
            {{ content ? content.length : 0 }}/1000
          </div>
        </b-form-group>
        <div
          v-show="broadcast.image"
          class="flex border p-2 border-2 rounded-lg  border-[#E2E2E2]  my-2 items-start gap-2"
        >
          <div>
            <b-img
              :src="broadcast.image"
              alt="icon-send"
              class="rounded-md object-cover w-[100px] h-[100px]"
            />
          </div>
          <div
            class="w-full"
          >
            <b-form-group
              label="Caption gambar (opsional)"
              label-for="caption"
            >
              <template #label>
                <div class="text-base">
                  Caption gambar (opsional)
                </div>
              </template>
              <b-form-textarea
                id="caption"
                v-model="broadcast.caption"
                disabled
                maxlength="1000"
                rows="1"
              />
            </b-form-group>
          </div>
        </div>
        <b-form-group
          id="broadcast-new-title-group"
          label="Judul Baru"
          label-for="broadcast-new-title"
        >
          <template #label>
            <div class="text-base">
              Judul Baru
            </div>
          </template>
          <b-form-input
            id="broadcast-new-title"
            v-model="broadcast.newTitle"
            placeholder="judul broadcast"
          />
        </b-form-group>

        <b-form-group
          v-if="broadcast.broadcast_mode === 'SCHEDULED'"
          label="Atur Waktu Kirim*"
        >
          <div class="flex gap-1">
            <div class="w-full">
              <date-range-picker
                ref="picker"
                v-model="dateRange"
                :locale-data="locale"
                single-date-picker
                :opens="'center'"
                class="w-100"
                :min-date="new Date()"
              >
                <template #input="picker">
                  <div class="flex items-center cursor-pointer">
                    <b-img
                      class="mr-1"
                      src="https://storage.googleapis.com/komerce/assets/icons/date-picker-icon.svg"
                    />
                    <span class="text-gray-600 font-normal">
                      {{ picker.startDate ? DAY_MONTH_YEAR(picker.startDate) : 'Pilih Tanggal' }}
                    </span>
                  </div>
                </template>
              </date-range-picker>
            </div>
            <div class="w-full">
              <b-form-timepicker
                v-model="broadcast.time"
                locale="id"
                placeholder="Jam"
                no-close-button
                class="h-[38px]"
              />
            </div>
          </div>
        </b-form-group>
        <div
          v-if="broadcast.broadcast_mode === 'SCHEDULED' && !isScheduledTimeValid"
          class="text-danger text-sm mt-1"
        >
          Waktu kirim tidak boleh kurang dari waktu saat ini
        </div>
      </div>

      <div class="border border-2 rounded-lg md:p-2 p-1 mt-2 border-[#E2E2E2]">
        <div
          v-if="broadcast.type === 'new'"
          class="receiver-section"
        >
          <ReceiverMessage
            :is-for-modal="true"
            :is-loading="isLoading"
            :search-receiver="searchReceiver"
            :group-contact="groupContact"
            :group-contact-selected="groupContactSelected"
            :disabled="groupContactIdsSelected.length > 0"
            @update:searchReceiver="handleSearchReceiver"
            @update:groupContactSelected="value => groupContactSelected = value"
            @nextDataGroup="getGroupContact(true)"
          />
          <div class="my-1">
            <div class="mb-[5px]">
              <span class="font-bold text-[12px] leading-[150%] tracking-[0.5px] align-middle">Jumlah Grup Kontak:</span> <span class="font-normal text-primary text-[15px] leading-[150%] tracking-[0.5px] align-middle">{{ groupContactSelected.length }}</span>
            </div>
            <div class="mb-[5px]">
              <span class="font-bold text-[12px] leading-[150%] tracking-[0.5px] align-middle">Jumlah Penerima:</span> <span class="font-normal text-primary text-[15px] leading-[150%] tracking-[0.5px] align-middle">{{ totalReceiver() }}</span>
            </div>
          </div>
        </div>
        <div v-if="broadcast.type === 'failed'">
          <div
            ref="scrollContainer"
            class="p-1 min-h-[150px] border border-2 rounded-lg border-[#E2E2E2]"
            @scroll="handleScroll"
          >
            <div
              v-for="contact in listFailedBroadcast"
              :key="contact.id"
              class="flex gap-2"
            >
              <div>
                {{ contact.receiver_name }}
              </div>
              <div>
                {{ contact.receiver_phone_number }}
              </div>
            </div>
          </div>
          <div class="mt-1  font-semibold">
            Jumlah Kontak Penerima: {{ broadcast.failed }}
          </div>
        </div>

      </div>
    </div>
    <template #modal-footer>
      <div class="flex w-full items-center gap-2">
        <div class="w-full">
          <b-button
            block
            class="!h-[38px]"
            variant="outline-primary"
            @click="handleCancel"
          >
            Batal
          </b-button>
        </div>
        <div class="w-full">
          <b-button
            block
            :disabled="disabled()"
            variant="primary"
            @click="sendBroadcast"
          >
            <div class="flex justify-center gap-1 items-center">
              <img
                :src="disabled() ? 'https://storage.googleapis.com/komerce/assets/komerce-icon/Putih/send-2.svg' : 'https://storage.googleapis.com/komerce/assets/LP-Komchat/send-uhuy.svg'"
                alt="icon-send"
                width="16"
                srcset=""
              > <div>Kirim Broadcast </div>
            </div>
          </b-button>
        </div>
      </div>
    </template>

  </b-modal>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import {
  LABELDAY, LABELMONTH, DAY_MONTH_YEAR, YYYYMMDD,
} from '@/libs/formatDate'
import ReceiverMessage from './ReceiverMessage.vue'
import { apiGetGroupContact } from '../service/api.groupContact.service'
import { apiResendBroadcast } from '../service/api.broadcast.service'

/**
 * ModalSendBroadcast component
 * Used for sending broadcast messages to new receivers or resending to failed contacts.
 */
export default {
  components: {
    ReceiverMessage,
    DateRangePicker,
  },
  props: {
    /**
     * Array of selected group contact IDs.
     */
    groupContactIdsSelected: {
      type: Array,
      default: () => [],
    },
    /**
     * Broadcast object containing details like id, title, content, type (new/failed), etc.
     */
    broadcast: {
      type: Object,
      default: () => {},
    },
    /**
     * List of contacts that failed to receive the broadcast.
     */
    listFailedBroadcast: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      /** Cursor for pagination of group contacts */
      cursor: 0,
      /** Limit of items per page */
      limit: 20,
      /** Search query for receiver/group contact */
      searchReceiver: '',
      /** Loading state for fetching data */
      isLoading: false,
      /** Flag indicating if all data has been loaded */
      isLastData: false,
      /** Array of group contacts fetched from API */
      groupContact: [],
      /** Debounce timer for search input */
      debounce: null,
      /** Array of selected group contacts */
      groupContactSelected: [],
      /** Index of the currently displayed content variant (spintax) */
      indexVariant: 0,
      // Date formatting helpers
      LABELDAY,
      LABELMONTH,
      DAY_MONTH_YEAR,
      YYYYMMDD,
      /** Current content being displayed */
      content: '',
      /** Name of the current variant (e.g., "Variant 1") */
      variantNames: '',
      /** Locale configuration for date picker */
      locale: {
        format: 'dd/mm/yyyy',
        daysOfWeek: LABELDAY,
        monthNames: LABELMONTH,
      },
    }
  },
  computed: {
    /**
     * Returns the content as an array if it's spintax (array), otherwise empty array.
     */
    spintaxContent() {
      if (Array.isArray(this.broadcast.content)) {
        return this.broadcast.content
      }
      return []
    },
    /**
     * Computed property for DateRangePicker v-model.
     * Maps broadcast.date (string YYYY-MM-DD) to/from Date object.
     */
    dateRange: {
      get() {
        return {
          startDate: this.broadcast.date || new Date(),
          endDate: this.broadcast.date || new Date(),
        }
      },
      set(val) {
        this.broadcast.date = YYYYMMDD(val.startDate)
      },
    },
    /**
     * Checks if the scheduled time is valid (greater than current time).
     * @returns {boolean} True if valid or not scheduled mode.
     */
    isScheduledTimeValid() {
      if (this.broadcast.broadcast_mode !== 'SCHEDULED') return true
      if (!this.broadcast.date || !this.broadcast.time) return false

      const scheduleDateTime = new Date(`${this.broadcast.date}T${this.broadcast.time}`)
      const currentDateTime = new Date()

      return scheduleDateTime > currentDateTime
    },
  },
  watch: {
    /**
     * Watches for changes in broadcast content to handle spintax variants.
     */
    'broadcast.content': {
      immediate: true,
      handler() {
        if (Array.isArray(this.broadcast.content)) {
          if (this.broadcast.content.length > 0) {
            this.indexVariant = 0
            this.content = this.broadcast.content[this.indexVariant]
            this.variantNames = this.indexVariant === 0 ? 'Pesan Utama' : `Variant ${this.indexVariant}`
          } else {
            this.indexVariant = 0
            this.content = ''
            this.variantNames = ''
          }
        } else {
          this.content = this.broadcast.content || ''
        }
      },
    },
    /**
     * Updates schedule string when time changes.
     */
    'broadcast.time': {
      immediate: true,
      handler() {
        this.broadcast.schedule = `${this.broadcast.date} ${this.broadcast.time}`
      },
    },
    /**
     * Updates schedule string when date changes.
     */
    'broadcast.date': {
      immediate: true,
      handler() {
        this.broadcast.schedule = `${this.broadcast.date} ${this.broadcast.time}`
      },
    },
  },
  mounted() {
    // getGroupContact sudah dipanggil oleh watcher groupContactIdsSelected jika ada nilai awal
    // Jika tidak ada nilai awal di groupContactIdsSelected, kita mungkin tetap ingin memuat daftar kontak awal
    if (!this.groupContactIdsSelected || this.groupContactIdsSelected.length === 0) {
      this.getGroupContact(false, false) // Load halaman pertama tanpa mencoba memilih apa pun
    }
  },
  methods: {
    /**
     * Fetches group contacts from API.
     * @param {boolean} isNextPage - Whether to load the next page of data.
     * @param {boolean} isInitialLoad - Whether this is the initial load.
     */
    async getGroupContact(isNextPage = false, isInitialLoad = false) {
      if (this.isLoading) return // Hindari pemanggilan ganda jika sedang loading

      if (!isNextPage) {
        this.cursor = 0
        // Reset groupContact hanya jika bukan initial load yang bertujuan untuk menambah data
        if (!isInitialLoad) {
          this.groupContact = []
        }
        // Reset groupContactSelected hanya jika ini bukan initial load yang dipicu oleh groupContactIdsSelected
        // atau jika groupContactIdsSelected memang kosong.
        if (!isInitialLoad || !this.groupContactIdsSelected || this.groupContactIdsSelected.length === 0) {
          this.groupContactSelected = []
        }
      } else if (this.isLastData) {
        return
      }

      this.isLoading = true
      try {
        const data = await apiGetGroupContact(
          this.searchReceiver,
          this.cursor,
          this.limit,
        )
        const newGroupContacts = data.data.data || []
        this.cursor = data.data.meta.pagination.next_cursor

        if (newGroupContacts.length < this.limit || !this.cursor) {
          this.isLastData = true
        } else {
          this.isLastData = false
        }

        if (isNextPage) {
          // Hindari duplikasi kontak jika ada yang sudah termuat
          const existingIds = new Set(this.groupContact.map(c => c.id))
          const uniqueNewContacts = newGroupContacts.filter(c => !existingIds.has(c.id))
          this.groupContact.push(...uniqueNewContacts)
        } else {
          this.groupContact = newGroupContacts
        }

        // Jika ini adalah load awal (atau bagian dari proses load berkelanjutan untuk groupContactIdsSelected)
        // dan groupContactIdsSelected ada, panggil setSelectedContactsFromIds.
        if (isInitialLoad && this.groupContactIdsSelected && this.groupContactIdsSelected.length > 0) {
          this.setSelectedContactsFromIds()
        }
      } catch (error) {
        this.$toast_error({ message: error?.response?.data?.meta?.message || 'Gagal memuat grup kontak' })
        if (!isNextPage) {
          this.groupContact = []
        }
      } finally {
        this.isLoading = false
      }
    },
    /**
     * Calculates the total number of receivers from selected groups.
     * @returns {number} Total receivers.
     */
    totalReceiver() {
      return this.groupContactSelected.map(item => item.total_contact).reduce((sum, current) => sum + current, 0)
    },
    /**
     * Handles search input for receivers with debounce.
     * @param {string} value - Search query.
     */
    handleSearchReceiver(value) {
      clearTimeout(this.debounce)

      // eslint-disable-next-line no-underscore-dangle
      this.debounce = setTimeout(() => {
        this.searchReceiver = value
        this.getGroupContact()
      }, 2000)
    },

    /**
     * Loads group contacts (seems redundant with getGroupContact, maybe legacy or specific use case?)
     * @param {boolean} isNextPage
     */
    async loadGroupContact(isNextPage = false) {
      if (!isNextPage) {
        this.cursor = 0
      } else if (this.isLastData) {
        return
      }

      this.isLoading = true
      try {
        const data = await apiGetGroupContact(
          this.searchReceiver,
          this.cursor,
          this.limit,
        )
        const groupContact = data.data.data
        this.cursor = data.data.meta.pagination.next_cursor

        if (groupContact.length < this.limit || this.cursor === undefined) {
          this.isLastData = true
        } else {
          this.isLastData = false
        }

        if (isNextPage) {
          this.groupContact.push(...groupContact)
        } else {
          this.groupContact = groupContact || []
        }
      } catch (error) {
        this.$toast_error({ message: error.response.data.meta.message })
        if (!isNextPage) {
          this.groupContact = []
        }
      } finally {
        this.isLoading = false
      }
    },
    /**
     * Sends the broadcast (resend or new).
     */
    async sendBroadcast() {
      try {
        await apiResendBroadcast(
          this.broadcast.id,
          this.groupContactSelected.map(item => item.id),
          this.broadcast.type === 'failed' ? 'failed_receiver' : 'new_receiver',
          this.broadcast.newTitle,
          this.broadcast.schedule,
        )
        this.$toast_success({ message: 'Berhasil mengirim broadcast' })
        this.$emit('refresh')
        this.$bvModal.hide('modal-send-broadcast')
      } catch (error) {
        this.$toast_error({ message: error.response.data.meta.message })
      }
    },
    /**
     * Handles scrolling in the failed receivers list to trigger infinite scroll.
     * @param {Event} event - Scroll event.
     */
    handleScroll(event) {
      const { scrollTop, scrollHeight, clientHeight } = event.target
      if (scrollTop + clientHeight >= scrollHeight - 1) {
        this.$emit('nextGetListFailed', true)
      }
    },
    /**
     * Checks if the send button should be disabled.
     * @returns {boolean} True if disabled.
     */
    disabled() {
      if (this.broadcast.type === 'failed') {
        return this.broadcast.newTitle === ''
      }
      if (this.broadcast.type === 'new') {
        if (this.broadcast.broadcast_mode === 'SCHEDULED' && !this.isScheduledTimeValid) {
          return true
        }
        return this.groupContactSelected.length === 0
      }
      return false
    },
    /**
     * Moves to the next or previous message variant.
     * @param {string} type - 'min' for previous, 'plus' for next.
     */
    handleMoveVariant(type) {
      if (type === 'min') {
        this.indexVariant -= 1
        this.content = this.spintaxContent[this.indexVariant]
        this.variantNames = this.indexVariant === 0 ? 'Pesan Utama' : `Variant ${this.indexVariant}`
      } else {
        this.indexVariant += 1
        this.content = this.spintaxContent[this.indexVariant]
        this.variantNames = this.indexVariant === 0 ? 'Pesan Utama' : `Variant ${this.indexVariant}`
      }
    },
    handleModalHidden() {
      this.searchReceiver = ''
      this.groupContactSelected.splice(0, this.groupContactSelected.length)
      this.indexVariant = 0
      this.$emit('hidden')

      this.getGroupContact(false, false)
    },
    handleCancel() {
      this.searchReceiver = ''
      this.groupContactSelected.splice(0, this.groupContactSelected.length)
      this.indexVariant = 0
      this.$emit('close')

      this.$bvModal.hide('modal-send-broadcast')
      // getGroupContact is called by modal hidden event anyway
    },
  },
}
</script>
